import { render } from "./ThirdParties.vue?vue&type=template&id=0b2281f6&scoped=true"
import script from "./ThirdParties.vue?vue&type=script&lang=js"
export * from "./ThirdParties.vue?vue&type=script&lang=js"

import "./ThirdParties.vue?vue&type=style&index=0&id=0b2281f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2281f6"]])

export default __exports__